import AdminEventAthletes from './athletes';

export default AdminEventAthletes;